<template>
<div id="secure">
    <NewTopMenu />
    <div class="container">

        <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
                <li>
                    <a v-on:click="goOverallAnalysis()">Overall Analysis</a>
                </li>
                <li class="is-active">
                    <a href="#">{{ behaviorName }} ({{ durationDisplay }})</a>
                </li>
            </ul>
        </nav>

        <div class="columns">
            <div class="column is-12">
                <div class="card is-hidden1">
                    <div class="card-header" style="padding: 10px;">
                        <div class="columns">
                            <div class="column">
                                <b-select id="category" name="category" v-model="category" size="is-small" style="margin-left: 10px;" @input="getSubmissionsByDuration(1)">
                                    <option selected value="school">All</option>
                                    <option v-for="kelas in kelasList" :key="kelas._id" :value="kelas._id">{{ kelas.level }} {{ kelas.name }}</option>
                                </b-select>
                            </div>
                            <div class="column">
                                <b-select id="duration" name="duration" v-model="duration" size="is-small" style="margin-left: 10px;"  @input="getSubmissionsByDuration(1)">
                                    <option selected value="daily">Daily</option>
                                    <option selected value="range">Monthly</option>
                                    <option selected value="yearly">Yearly</option>
                                </b-select>
                            </div>
                            <div class="column" style="z-index: 100 !important;">
                                <datepicker @closed="getSubmissionsByDuration(1)"  v-model="selectedDate" wrapper-class="myDatepickerClass" placeholder="Select Date" :value="selectedDate" :class="$style.datepicker" :calendar-button="true" calendar-button-icon="fa fa-calendar" v-show="duration=='daily'"/>
                                <b-select id="durationMonthly" name="durationMonthly" v-model="durationMonthly" size="is-small" style="margin-left: 10px;" @input="getSubmissionsByDuration(1)" v-show="duration=='range'">
                                    <option selected value="1">January</option>
                                    <option selected value="2">February</option>
                                    <option selected value="3">March</option>
                                    <option selected value="4">April</option>
                                    <option selected value="5">May</option>
                                    <option selected value="6">June</option>
                                    <option selected value="7">July</option>
                                    <option selected value="8">August</option>
                                    <option selected value="9">September</option>
                                    <option selected value="10">October</option>
                                    <option selected value="11">November</option>
                                    <option selected value="12">December</option>
                                </b-select>
                                <b-select id="year" name="year" v-model="year" size="is-small" style="margin-left: 10px;" @input="getSubmissionsByDuration(1)" v-show="duration=='yearly'">
                                    <option :value="lastYear">{{ lastYear }}</option>
                                    <option selected :value="currentYear">{{ currentYear }}</option>
                                    <option :value="nextYear">{{ nextYear }}</option>
                                </b-select>
                            </div>
                            <div class="column">
                                <a class="button is-info is-small" v-on:click="downloadAsExcel()">Download As Excel</a>
                            </div>
                        </div>
                    </div>
                    <div class="card-content" style="min-height: 300px !important;">
                        <loading :active.sync="isLoading" 
                            :can-cancel="false" 
                            :is-full-page="true">
                        </loading>
                        <table class="table is-fullwidth is-striped">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Student</th>
                                    <th v-show="category=='school'">Class</th>
                                    <th>Date &amp; Time</th>
                                    <th>Total Points <br/><b>{{ roundTo2DecimalPlaces(totalPoints) }}</b></th>
                                    <th>Remarks</th>
                                    <th>&nbsp;</th>
                                    <th>Image</th>
                                    <th>Location</th>
                                    <th>Awarded by</th>
                                    <th><a class="button is-warning is-small" v-on:click="revokePoints()">Revoke</a><br/><small><a v-on:click="checkAll">Check all</a></small></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(submission,index) in sortSubmissions(submissionList)" :key="submission._id">
                                    <td>{{ (index + 1) }}</td>
                                    <td>{{ submission.studentID.firstName }} {{ submission.studentID.lastName }}</td>
                                    <td v-show="category=='school'">{{ submission.kelasID.level }} {{ submission.kelasID.name }}</td>
                                    <td>{{ displayDate(submission.actionDate) }}, {{ submission.actionTime }}</td>
                                    <td>{{ submission.points }} x {{ submission.multiply }} = <b>{{ roundTo2DecimalPlaces(submission.totalPoints) }}</b></td>
                                    <td>{{ displayInfo(submission.dataType,submission.remarks,submission.status) }}</td>
                                    <td>{{ submission.remarks2 }}</td>
                                    <td v-show="submission.image01.length > 3"><i class="fa fa-picture-o" v-on:click="viewImage(submission.image01)"></i></td>
                                    <td v-show="submission.image01.length < 3">&nbsp;</td>
                                    <td v-show="submission.latlngLabel.length > 3"><b-button type="is-link is-light is-small" v-on:click="viewLocation(submission.latlng)">{{ submission.latlngLabel }}</b-button></td>
                                    <td v-show="submission.latlngLabel.length < 3">&nbsp;</td>
                                    <td>{{ submission.teacherID.firstName }} {{ submission.teacherID.lastName }}</td>
                                    <td><center><input type="checkbox" :value="setCheckedValue(submission.dataType,submission._id,submission.studentID._id,submission.actionDate)" :id="setCheckedValue(submission.dataType,submission._id,submission.studentID._id,submission.actionDate)" v-model="submission.checked"/></center></td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- <div class="columns bottom-border">
                            <div class="column">#</div>
                            <div class="column">Student</div>
                            <div class="column" v-show="category=='school'">Class</div>
                            <div class="column text-center">Date &amp; Time</div>
                            <div class="column text-center">Total Points <br/><b>{{ roundTo2DecimalPlaces(totalPoints) }}</b></div>
                            <div class="column">Remarks</div>
                            <div class="column">&nbsp;</div>
                            <div class="column text-center">Image</div>
                            <div class="column is-2 text-center">Location</div>
                            <div class="column">Awarded by</div>
                            <div class="column is-1" style="padding: 0px; text-align: center;">
                                <a class="button is-warning is-small" v-on:click="revokePoints()">Revoke</a><br/>
                                <small><a v-on:click="checkAll">Check all</a></small>
                            </div>
                        </div>
                        <div class="columns" v-for="(submission,index) in sortSubmissions(submissionList)" :key="submission._id">
                            <div class="column">{{ (index + 1) }} </div>
                            <div class="column">{{ submission.studentID.firstName }} </div>
                            <div class="column" v-show="category=='school'">{{ submission.kelasID.level }} {{ submission.kelasID.name }}</div>
                            <div class="column text-center">{{ displayDate(submission.actionDate) }}, {{ submission.actionTime }} </div>
                            <div class="column text-center">{{ submission.points }} x {{ submission.multiply }} = <b>{{ roundTo2DecimalPlaces(submission.totalPoints) }}</b></div>
                            <div class="column">{{ displayInfo(submission.dataType,submission.remarks,submission.status) }}</div>
                            <div class="column">{{ submission.remarks2 }}</div>
                            <div class="column text-center" v-show="submission.image01.length > 3"><i class="fa fa-picture-o" v-on:click="viewImage(submission.image01)"></i></div>
                            <div class="column" v-show="submission.image01.length < 3">&nbsp;</div>
                            <div class="column is-2 text-center" v-show="submission.latlngLabel.length > 3"><b-button type="is-link is-light is-small" v-on:click="viewLocation(submission.latlng)">{{ submission.latlngLabel }}</b-button></div>
                            <div class="column is-2" v-show="submission.latlngLabel.length < 3">&nbsp;</div>
                            <div class="column">{{ submission.teacherID.firstName }} {{ submission.teacherID.lastName }}</div>
                            <div class="column is-1"><center><input type="checkbox"  :value="setCheckedValue(submission.dataType,submission._id,submission.studentID._id,submission.actionDate)" :id="setCheckedValue(submission.dataType,submission._id,submission.studentID._id,submission.actionDate)" v-model="submission.checked"></center></div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./NewTopMenu";
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import Datepicker from 'vuejs-datepicker';
import 'vue-loading-overlay/dist/vue-loading.css';
import "./public/style.scss";
const helper = require("../../config/helper")

export default {
    name: "SubmissionDetails",
    components: {
        NewTopMenu,
        Loading,
        Datepicker,
    },
    data() {
        return {
            schoolID: "",
            kelasID: "",
            kelasList: [],
            submissionList: [],
            isLoading: false,
            behaviorID: "",
            behaviorName: "",
            category: "school",
            duration: "daily",
            startDate: "",
            endDate: "",
            durationMonthly: 0,
            year: 0,
            selectedDate: "",
            durationDisplay: "",
            totalPoints: 0,
            tempCaller: 0,
            currentYear: 0,
            lastYear: 0,
            nextYear: 0,
            year: 0,
            actionDate: ""
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    created() {
        var currentDate = new Date();
        this.currentYear = currentDate.getFullYear()
        this.lastYear = this.currentYear - 1
        this.nextYear = this.currentYear + 1

        this.schoolID = localStorage.getItem('schoolID');
        
        this.behaviorID = this.$store.getters.getViewSubmissionsBehaviorID;
        if (this.behaviorID.length < 1){
            this.behaviorID = localStorage.getItem('VIEW_SUBMISSIONS_BEHAVIOR_ID')
        }
        
        this.behaviorName = this.$store.getters.getViewSubmissionsBehaviorName;
        if (this.behaviorName.length < 1){
            this.behaviorName = localStorage.getItem('VIEW_SUBMISSIONS_BEHAVIOR_NAME')
        }

        console.log("151 this.behaviorName: " + this.behaviorName)
        
        this.category = this.$store.getters.getViewSubmissionsCategory;
        if (this.category.length < 1){
            this.category = localStorage.getItem('VIEW_SUBMISSIONS_CATEGORY')
        }

        console.log("148 this.category: " + this.category)
        console.log("148 this.behaviorID: " + this.behaviorID)
        
        this.duration = this.$store.getters.getViewSubmissionsDuration;
        if (this.duration.length < 1){
            this.duration = localStorage.getItem('VIEW_SUBMISSIONS_DURATION')
        }
        
        this.startDate = this.$store.getters.getStartDate;
        if (this.startDate.length < 1){
            this.startDate = localStorage.getItem('START_DATE')
        }
        console.log("222 this.startDate: " + this.startDate)

        this.endDate = this.$store.getters.getEndDate;
        if (this.endDate.length < 1){
            this.endDate = localStorage.getItem('END_DATE')
        }
        console.log("222 this.endDate: " + this.endDate)

        this.year = this.$store.getters.getYear;
        if (this.year < 1){
            this.year = localStorage.getItem('YEAR')
        }
        console.log("222 this.year: " + this.year)
        
        this.actionDate = this.$store.getters.getActionDate;
        if (this.actionDate.length < 1){
            this.actionDate = localStorage.getItem('ACTION_DATE')
        }
        console.log("240 this.actionDate: " + this.actionDate)

        var tempGetYear = 0
        var tempStrGetMonth = ""
        var tempGetMonth = 0
        var tempGetDay = 0

        if (this.duration == "daily"){
            this.startDate = this.actionDate   
        }
        try{
            tempGetYear = this.startDate.substring(0,4)
            tempStrGetMonth = this.startDate.substring(4,6)
            tempGetMonth = parseInt(tempStrGetMonth)
            tempGetMonth = tempGetMonth
            tempGetDay = parseInt(this.startDate.substring(6,8))
            this.selectedDate = new Date(tempGetYear,tempGetMonth-1,tempGetDay)
        }catch(err){
            console.log("172 error parsing this.startDate, so default to today date")
            var currentDate = new Date();
            this.selectedDate = new Date(currentDate.getFullYear(),currentDate.getMonth(),currentDate.getDate())
        }
        console.log("252 this.selectedDate: " + this.selectedDate)

        console.log("252 this.duration: " + this.duration)

        if (this.duration == "daily"){
            this.durationDisplay = helper.displayActionDate(this.startDate)
        }else if (this.duration == "range"){
            this.durationDisplay = helper.displayMonth(this.durationMonthly) + " " + this.year
            this.durationMonthly = tempGetMonth
        }else{
            this.durationDisplay = this.year
        }
        console.log("252 this.durationMonthly: " + this.durationMonthly)

        this.getClassList()
        this.getSubmissionsByDuration(0)
    },
    mounted(){
    },
    methods: {
        getSubmissionsByDuration(caller){
            let self = this
            self.isLoading = true;

            self.tempCaller = caller
            if (self.duration == "daily"){
                if (caller == 1){   //called from datepicker
                    var getDate = self.selectedDate.getDate();
                    var getMonth = self.selectedDate.getMonth() + 1;
                    if (getDate < 10){
                        getDate = "0" + getDate
                    }
                    if (getMonth < 10){
                        getMonth = "0" + getMonth
                    }
                    self.startDate = self.selectedDate.getFullYear() + "" + getMonth + "" + getDate;
                }
                self.durationDisplay = helper.displayActionDate(self.startDate)

            }else if (self.duration == "range"){
                self.durationDisplay = helper.displayMonth(self.durationMonthly) + " " + self.year

                var strMonth = self.durationMonthly
                if (strMonth < 10){
                    strMonth = "0" + strMonth
                }
                var daysInMonth = helper.getDaysInMonth(self.durationMonthly,self.year)
                self.startDate = this.currentYear + "" + strMonth + "01"
                self.endDate = this.currentYear + "" + strMonth + "" + daysInMonth
            }else{
                self.durationDisplay = self.year
            }
            
            this.$gtag.event('SubmissionDetails', {
                'event_category': self.category,
                'event_label': localStorage.getItem('schoolName'),
                'value': localStorage.getItem('schoolID')
            })

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/submissions/detail/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                category: self.category,
                behaviorID: self.behaviorID,
                duration: self.duration,
                startDate: self.startDate,
                endDate: self.endDate,
                year: self.year
            })
            .then(response => {
                self.submissionList = response.data.submissions
                self.totalPoints = 0
                for (var i = 0; i < self.submissionList.length; i++){
                    self.submissionList[i].checked = false;
                    if (!self.submissionList[i].image01){
                        self.submissionList[i].image01 = ""
                    }
                    if (!self.submissionList[i].latlngLabel){
                        self.submissionList[i].latlngLabel = ""
                    }
                    self.totalPoints = self.totalPoints + self.submissionList[i].totalPoints;
                }
                self.isLoading = false
            })
            .catch(e => {
                console.log(e)
                self.isLoading = false
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })
        },
        checkAll: function() {
            this.submissionList = this.submissionList.map(behavior => ({ ...behavior,
                checked: !this.isAllChecked
            }))
            this.isAllChecked = !this.isAllChecked
        },
        setCheckedValue(dataType,id,studentID,actionDate){
            return "1:" + dataType + "|2:" + id + "|3:" + studentID + "|4:" + actionDate
        },
        revokePoints(){
            let self = this;
            var submissionsToRevoke = [];

            self.submissionList.forEach(function(element) {
                if (element.checked){
                    var elementID = self.setCheckedValue(element.dataType,element._id,element.studentID._id,element.actionDate)
                    submissionsToRevoke.push(elementID)
                }
            });
                        
            if (submissionsToRevoke.length > 0){

                this.$swal({
                    title: "Are you sure?",
                    text: "Are you sure you want to revoke the selected submissions?",
                    showCancelButton: true,
                    confirmButtonText: 'Yes, revoke',
                    cancelButtonText: 'No, cancel',
                    showCloseButton: true
                }).then((result) => {
                    if (result.value){                        
            
                        this.$gtag.event('SubmissionDetails', {
                            'event_category': 'revoke',
                            'event_label': localStorage.getItem('schoolName'),
                            'value': localStorage.getItem('schoolID')
                        })

                        axios.defaults.responseType = 'json'
                        axios.post(process.env.NEW_ENDPOINT + '/submissions/revoke/', {
                            token: localStorage.getItem('jwtTokenV2'),
                            email: localStorage.getItem('email'),
                            submissionsToRevoke: submissionsToRevoke
                        })
                        .then(response => {
                            console.log("313 response.data: ")
                            console.log(response.data)
                            self.isLoading = false
                            
                            if (response.data.success == false) {
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    message: response.data.msg,
                                    type: 'is-success',
                                    duration: 3000
                                })
                            }
                            self.getSubmissionsByDuration(self.tempCaller)
                        })
                        .catch(e => {
                            console.log(e)
                            self.isLoading = false
                            if (e.response.status === 401) {                            
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    message: 'Error: ' + e.response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            }
                        })
                    }
                })
            }else{
                Toast.open({
                    message: "Please select the submission(s) you want to revoke first",
                    type: 'is-warning', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }            
        },
        downloadAsExcel(){
            let self = this;
            axios.defaults.responseType = 'blob'
            axios.post(process.env.MY_URL + '/exportToExcelV2/submissionDetails', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                data: self.submissionList,  //self.submissionList would already contain the data we want to export to excel
                category: self.category,
                behaviorID: self.behaviorID,
                duration: self.duration,
                startDate: self.startDate,
                endDate: self.endDate,
                year: self.year
            })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', "Submission Details.xlsx");
                document.body.appendChild(link);
                link.click();         
                self.isLoading = false
            })
            .catch(e => {
                console.log(e)
                self.isLoading = false
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })

        },
        sortSubmissions(arrays){
            if (this.sortBy == 1){  //points
                return _.orderBy(arrays, 'totalPoints', 'desc');  //we're using the magical lodash function here
            }else{  //dates
                return _.orderBy(arrays, 'actionDate', 'desc');  //we're using the magical lodash function here
            }            
        },
        displayDate(date){
            try{
                var getYear = date.substring(0,4);
                var getMonth = date.substring(4,6);
                var getDay = date.substring(6);

                return getDay + "/" + getMonth + "/" + getYear;
            }catch(err){
                console.log(err)
                return date;
            }
        },
        displayInfo(dataType,remarks,status){
            if (dataType == 2){
                if (status == 2){
                    return "Late"
                }else{
                    return "On-Time"
                }
            }else{
                return remarks
            }
        },
        getClassList(){
            let self = this

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/classes/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
            .then(response => {
                self.kelasList = response.data.kelasList                
            })
            .catch(e => {
                console.log(e)
            })
        },
        goOverallAnalysis() {
            this.$router.push({
                name: "OverallAnalysis"
            });
        },
        viewImage(image){
            window.open("https://upload-face.studentqr.com/" + image, '_blank');
        },
        viewLocation(latlng){
            window.open("https://maps.google.com/?q=" + latlng, '_blank');
        },
        roundTo2DecimalPlaces(points){  //use lodash to round the points to 2 decimal places
            return _.round(points, 2)
            // return _.round(points, 2).toFixed(2)
        },
    },
};
</script>

<style scoped>
.myDatepickerClass{
    margin-top: 2px;
    border: 1px dotted #000;
    width: 115%;
}
.datepicker{
    margin-left: 10px;
    margin-top: 2px;
}
.bottom-border{
    border-bottom: 1px solid #CCC
}
.container{
    padding: 10px;
}
.text-center{
    text-align: center;
}
</style>
<style module>
.datepicker input{
    border: none; /* <-- This thing here */
    border:1px solid #1849c8;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/SubmissionDetails.vue